import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownFilterPanelComponent } from '@app/shared/components/dropdown-filter-panel/dropdown-filter-panel.component';
import { InitialPipe } from '@app/shared/pipes/initial.pipe';
import { FilterUser } from '../../interfaces/committee-audit-log.interface';
import { onImageError } from '@app/shared/utils/helper';
import { AvatarModule } from 'primeng/avatar';
import { DatePickerModule } from 'primeng/datepicker';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'lfx-committee-audit-filters-panel',
  standalone: true,
  imports: [FormsModule, MultiSelectModule, AvatarModule, DatePickerModule, SelectModule, InitialPipe, DropdownFilterPanelComponent],
  templateUrl: './committee-audit-filters-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommitteeAuditFiltersPanelComponent {
  public period = model<string>('all');
  public dateFrom = model<Date | null>(null);
  public dateTo = model<Date | null>(null);
  public selectedTypes = model<string[]>([]);
  public selectedActions = model<string[]>([]);
  public selectedCommittees = model<string[]>([]);
  public selectedMembers = model<string[]>([]);
  public selectedUsers = model<FilterUser[]>([]);
  public selectedFields = model<string[]>([]);

  public periodOptions = input<{ label: string; value: string }[]>([]);
  public typeOptions = input<string[]>([]);
  public actionOptions = input<string[]>([]);
  public committeeOptions = input<string[]>([]);
  public memberOptions = input<string[]>([]);
  public userOptions = input<FilterUser[]>([]);
  public fieldOptions = input<string[]>([]);
  public showCommitteeFilter = input<boolean>(false);
  public activeFilterCount = input<number>(0);

  public readonly filtersCleared = output<void>();
  public readonly onImageError = onImageError;

  public clearFilters(): void {
    this.period.set('all');
    this.dateFrom.set(null);
    this.dateTo.set(null);
    this.selectedTypes.set([]);
    this.selectedActions.set([]);
    this.selectedCommittees.set([]);
    this.selectedMembers.set([]);
    this.selectedUsers.set([]);
    this.selectedFields.set([]);
    this.filtersCleared.emit();
  }
}
